import React from "react";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import { ThemeProvider } from "@material-ui/core/styles";
import mainTheme from "./Themes/mainTheme";
import css from "./App.module.css";
import Container from "@material-ui/core/Container";
import CalculatePriceContainer from "./Components/CalculateContainer/CalculatePriceContainer";
import Divider from '@material-ui/core/Divider';

const App = () => {
  return (
    <>
      <ThemeProvider theme={mainTheme}>
        <div className={css.App}>
          <header className={css.Header}>
            <Container maxWidth="md">
              <Header></Header>
            </Container>
          </header>
          <main className={css.Main}>
            <Container maxWidth="md">
              <CalculatePriceContainer></CalculatePriceContainer>
            </Container>
          </main>
          <footer className={css.Footer}>
            <Container maxWidth="md">
            <Divider light />
              <Footer></Footer>
            </Container>
          </footer>
        </div>
      </ThemeProvider>
    </>
  );
};

export default App;
